import { cn } from '../../lib/utils';
import { Skeleton, SkeletonGroup } from '../portal';

/** Mirrors a `FieldLabel` (20px) over a 40px `Input`. */
export function FieldSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex h-5 items-center">
        <Skeleton className="h-3.5 w-24" />
      </div>
      <Skeleton className="h-10 w-full" rounded="lg" />
    </div>
  );
}

/** Mirrors a `SettingsFact`: 20px label over a 20px value line. */
export function FactSkeleton() {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex h-5 items-center">
        <Skeleton className="h-3.5 w-24" />
      </div>
      <div className="flex h-5 items-center">
        <Skeleton className="h-3.5 w-40" />
      </div>
    </div>
  );
}

interface SectionSkeletonProps {
  /** Number of placeholder rows; match the section's real field count. */
  rows?: number;
  /** `fact` swaps the 40px inputs for 20px value lines. */
  variant?: 'field' | 'fact';
  className?: string;
}

/** Whole-card placeholder for a `SettingsSection` (header row + rows). */
export function SectionSkeleton({
  rows = 2,
  variant = 'field',
  className,
}: SectionSkeletonProps) {
  const Row = variant === 'fact' ? FactSkeleton : FieldSkeleton;

  return (
    <SkeletonGroup
      className={cn(
        'flex flex-col gap-6 rounded-lg border border-seeker-800 bg-seeker-900 p-6 sm:p-8',
        className,
      )}
    >
      <div className="flex h-5 items-center">
        <Skeleton className="h-3.5 w-32" />
      </div>
      <div className="flex flex-col gap-6">
        {Array.from({ length: rows }, (_, index) => (
          <Row key={index} />
        ))}
      </div>
    </SkeletonGroup>
  );
}
